import { ATTACHMENTS_VALIDATION } from "../../../enums/Request/currentRequestControls.types";

export const attachmentsValidation = (data) => {
    return {
        type: ATTACHMENTS_VALIDATION,
        payload: data,
    };
};
